import React from 'react'
import qs from 'qs'
import {ErrorModal, UserConfirmationModal, UserSelectionModal, ErrorTextBlock} from '../ui/'

export const setupPropsForPage = (props, page) => {
    const {token, user, location, history, match} = props
    page.token = token
    page.user = user
    page.location = location
    page.history = history

    page.urlParams = {}
    if (match && match.params) {
        page.urlParams = match.params
    }

    page.queryParams = {}
    if (location.search) {
        page.queryParams = qs.parse(location.search.slice(1))
    }
}

export const dismissErrorOnPage = (error, page) => {
    let errors = page.state.errors.filter((e) => e !== error)
    page.setState({errors})
}

export const renderErrorModalsForPage = (errors, page, className='') => {
    return errors.map((appError, idx) =>
        <ErrorModal key={idx}
                     modal={true}
                     className={className}
                     toggle={() => (dismissErrorOnPage(appError, page))}
                     text={appError.text}
                     title={appError.title}/>)
}

export const renderErrorTextBlocks = (errors, className='') => {
    return errors.map((appError, idx) =>
        <ErrorTextBlock key={idx}
                          className={className}
                          text={appError.text}
                          title={appError.title}/>)
}

export const renderUserConfirmationModals = (userConfirmationRequests) => {
    return userConfirmationRequests.map((req, idx) => {
        console.log(req)
        return <UserConfirmationModal key={`confirmation-request-${idx}`}
                               modal={true}
                               toggle={req.dismiss}
                               submit={()=>(req.confirmObject && req.confirm ? req.confirm(req.confirmObject) : (req.confirm ? req.confirm(): void(0)))}
                               title={req.title}
                               text={req.text}/>})
}

export const renderUserSelectionModals = (userSelectionRequests) => {
    return userSelectionRequests.map((req, idx) =>
        <UserSelectionModal key={`selection-request-${idx}`}
                               modal={true}
                               toggle={req.dismiss}
                               submit={req.select}
                               title={req.title}
                               text={req.text}
                               choices={req.choices}/>)
}

export const dismissUserConfirmationRequestOnPage = (confirmationRequest, page) => {
    let userConfirmationRequests = page.state.userConfirmationRequests.filter((r) => r !== confirmationRequest)
    page.setState({userConfirmationRequests})
}

export const dismissAllUserConfirmationRequestsOnPage = (page) => {
    page.setState({userConfirmationRequests: []})
}

export const dismissUserSelectionRequestOnPage = (selectionRequest, page) => {
    let userSelectionRequests = page.state.userSelectionRequests.filter((r) => r !== selectionRequest)
    page.setState({userSelectionRequests})
}

const removeAllSingleRunAnimationClasses = () => {
    let elements = document.querySelectorAll("*[class^=\"animate-once\"]")
    if (elements && elements.length && elements.map) {
        elements.map(el => {
            let classes = el.className.split(" ").filter(c => c.lastIndexOf("animation", 0) !== 0)
            el.className = classes.join(" ").trim()
        })
    }
}

export const setupSingleRunAnimationEvents = () => {
    window.addEventListener("transitionend", removeAllSingleRunAnimationClasses)
}

export const tearDownSingleRunAnimationEvents = () => {
    window.removeEventListener("transitionend", removeAllSingleRunAnimationClasses)
}

export const handleInvalidFormSubmit = (event, errors, values) => {
    console.log("GOT INVALID FORM SUBMIT" +
        "")
    console.log(event)
    console.log(errors)
    console.log(values)
    errors.map(e => {
        let element = document.querySelectorAll(`input[name="${e}"]`)[0]
        element.classList.add("animate-once-shake")
    })
}

export const userOnMobileDevice = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/windows phone/i.test(userAgent)) {
        return true
    } else if (/android/i.test(userAgent)) {
        return true
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true
    } else {
        return false
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/pageHelpers.js